import { render, staticRenderFns } from "./Herder.vue?vue&type=template&id=72b21ebd&scoped=true&"
import script from "./Herder.vue?vue&type=script&lang=js&"
export * from "./Herder.vue?vue&type=script&lang=js&"
import style0 from "./Herder.vue?vue&type=style&index=0&id=72b21ebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b21ebd",
  null
  
)

export default component.exports